import React, { useState } from 'react';
import css from './HomepageFAQ.module.css';

const FAQS = [
  {
    q: 'Is Rennzone the same as Rennlist, RennParts, or Rennworks?',
    a: 'No. Rennzone is an independent Porsche marketplace, not affiliated with Rennlist, RennParts, Rennworks, or any other "Renn" branded platform. Rennzone is a dedicated buying and selling marketplace for Porsche cars, parts, and memorabilia — built specifically for the global Porsche community.',
  },
  {
    q: 'Is Rennzone free to use?',
    a: 'Browsing all listings on Rennzone is completely free. You only need an account to contact a seller or create a listing.',
  },
  {
    q: 'Does Rennzone list Porsche parts and memorabilia as well as cars?',
    a: 'Yes — Rennzone covers Porsche road cars, race cars, parts, books, factory literature, memorabilia, and collectibles. Every listing is Porsche.',
  },
  {
    q: 'Is Rennzone global or UK-only?',
    a: 'Rennzone is a global marketplace with sellers and buyers across Europe, North America, the Middle East, and Asia-Pacific.',
  },
];

// FAQPage JSON-LD: tells Google the page contains structured FAQ content,
// so the homepage can earn an FAQ rich result for renn* brand-confusion searches.
// The same questions and answers are also rendered as visible HTML (always
// in the DOM, just collapsed visually) so they match the structured data.
const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={css.item}>
      <button
        className={css.question}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span>{q}</span>
        <span className={`${css.icon} ${open ? css.iconOpen : ''}`}>+</span>
      </button>
      {/* Always render the answer in the DOM so it's in the SSR'd HTML for
          SEO — visually collapsed via CSS unless the user expands it. */}
      <p
        className={`${css.answer} ${open ? css.answerOpen : ''}`}
        aria-hidden={!open}
      >
        {a}
      </p>
    </div>
  );
};

const HomepageFAQ = () => {
  return (
    <section className={css.section}>
      <div className={css.inner}>
        <h2 className={css.heading}>Frequently Asked Questions</h2>
        <div className={css.list}>
          {FAQS.map((item, i) => (
            <FAQItem key={i} q={item.q} a={item.a} />
          ))}
        </div>
      </div>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
};

export default HomepageFAQ;
